import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './EvCastEditor.html?raw';

import _StatefulSection from '../../moreCore/UI/_StatefulSection/_StatefulSection';
import _uiFrameMixin from '../../moreCore/UI/Container/uiFrame';
import { VAM2types } from "../_loadingHelpers/VAMv2Types";
import lang from 'dojo/_base/lang';
import Edit from '../../moreCore/UI/Edit/Edit';
import SearchSelect from '../../moreCore/UI/SearchSelect/SearchSelect';

class EvCastEditor extends compose(_StatefulSection, _uiFrameMixin) {
    templateString: any = template;

    private inputCastAddress: MdsLax<InstanceType<typeof Edit>>;
    private inputCastPerformer: MdsLax<InstanceType<typeof Edit>>;
    private inputStatus: MdsLax<InstanceType<typeof SearchSelect>>;

    protected afterSetData() {
        if (this.getAttributeValue("ref_performer")) {
            this.inputCastAddress.setReadonly(true);
            this.inputCastPerformer.setReadonly(true);
            if (this.hasFeature("Planning/EvCastStatus")) this.createDefaultButton("ok", lang.hitch(this, this._onClickConfirm));
        } else {
            this.UiModder.domClass.toggle(this.inputCastAddress.inputNode, "w3-text-red", true);
            this.UiModder.domClass.toggle(this.inputCastPerformer.inputNode, "w3-text-red", true);
            this.createDefaultButton("ok", lang.hitch(this, this._onClickConfirm));


            //this.voiceAttributeEditForm.destroy();
            //this.hideNode(this.voiceAttributeContainer, true);
        }

        if (this.hasFeature("Planning/EvCastStatus") && this.inputStatus) {
            let status = this.getAttributeValue("ref_ev_cast_status");
            this._loadStatusValues(status);
        }
    }

    private _loadStatusValues(status: more.EntityAPIResultExtended) {
        this.RequestManager.callfunction("Webtool_API__EVCastEditor_LoadStatusValues", {}, lang.hitch(this, this._onLoadStatusValuesResponse, status), lang.hitch(this, this._onLoadStatusValuesError));
    }

    private _onLoadStatusValuesResponse(status: more.EntityAPIResultExtended, response) {
        this.inputStatus.setData(status, response);
    }

    private _onLoadStatusValuesError(error) {
        console.error(error);
    }

    setup(cast: VAM2types.EvCast | VAM2types.EvCastEvProject) {
        this.setData(cast);

        this.show("dlg", cast.$Displayname);
        this._uiFrameDlg.enableContentOverflow(true);

    }

    private _onClickConfirm() {
        this.emit("confirmed", this.getCurrentData());
        this.close();
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(EvCastEditor);
